<template>
    <el-table class="yq-table"
            :data="data"
            style="width: 100%">
        <el-table-column v-for="field in fields" :key="field.name"
                         :prop="field.name"
                         :label="field.title"
                         :min-width="field.displayWidth">
            <news-field slot-scope="scope" :data="scope.row" :field="field"></news-field>
        </el-table-column>
        <slot></slot>
        <el-table-column label="操作" :width="opsWidth" :fixed="fixOps?'right':null">
            <span slot-scope="scope">
                <el-link @click="showDetails(scope.row.id)">详情</el-link>
                <slot name="ops" v-bind="scope"></slot>
            </span>
        </el-table-column>
    </el-table>
</template>

<script>
    import NewsField from './NewsField'
    export default {
        name: "NewsList",
        components: {NewsField},
        props: {
            data: Array,
            datasource: Object,
            viewName: String,
            opsWidth: {
                type: String,
                default: '50'
            },
            fixOps: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            fields() {
                return this.datasource.fields.filter(field =>
                    (field.displayInIndex && this.viewName === 'index') || (field.displayInList && this.viewName === 'list') ||
                    (field.displayInDetails && this.viewName === 'details')).sort((a, b) => {
                    if (this.viewName === 'index') {
                        return a.seqNoInIndex - b.seqNoInIndex
                    } else if (this.viewName === 'list') {
                        return a.seqNoInList - b.seqNoInList
                    } else {
                        return a.seqNoInDetails - b.seqNoInDetails
                    }
                })
            }
        },
        methods: {
            showDetails(id) {
                this.$emit('show-details', id)
            }
        }
    }
</script>

<style scoped>

</style>
